export enum CART_ERROR_CTA {
    CLEAR_CART = "clearcart",
    REMOVE_SUPER = "removesuper",
    REMOVE_UNAVAILABLE_ITEMS = "removeunavailableitems",
    VIEW_SIMILAR_RESTAURANTS = "viewsimilarrestaurants",
    GOTO_SIMILAR_RESTAURANTS = "gotosimilarrestaurants",
    GO_TO_HOME = "gotohome",
    RETRY = "retry",
    SELECT_ANOTHER_SLOT = "selectanotherslot",
    ADD_MORE_ITEMS = "addmoreitems",
    REMOVE_EXCESS_ITEMS = "removeexcessitems",
    GO_TO_GIFTING_HOME = "gotogiftinghome",
    ADD_MORE_GIFTS = "addmoregifts",
    REMOVE_UNSERVICEABLE_ITEMS = "removeunserviceableitems",
    KEEP_ALL_ITEMS = "keepallitems",
    ENTER_PNR = "enterpnr",
    SELECT_ANOTHER_STATION = "selectanotherstation",
}
